var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-col',[_c('v-col',[_c('h1',[_vm._v(_vm._s(_vm.$t("accessibility-heading")))])]),_c('v-divider'),_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.$t("accessibility-content")))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }